import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="py-10 md:py-14 px-4 md:px-6 bg-background-100 border-t border-background-200">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6 mb-8">
          <div className="text-center md:text-left">
            <h3 className="text-lg font-heading font-bold text-foreground-950 mb-1">
              Sugargoo Spreadsheet Hub
            </h3>
            <p className="text-xs md:text-sm text-foreground-500">
              The independent resource for smarter international shopping
            </p>
          </div>
          <div className="flex items-center gap-4">
            <Link
              to="/"
              className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              Home
            </Link>
            <Link
              to="/sugargoo-spreadsheet-guide"
              className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              Complete Guide
            </Link>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              Main Website
            </a>
          </div>
        </div>
        <div className="border-t border-background-200 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} Sugargoo Spreadsheet Hub. All rights reserved. Independent resource — not affiliated with Sugargoo.
          </p>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-1.5 px-4 py-2 bg-primary-500 text-white text-xs font-semibold rounded-full hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-shopping-bag-line"></i>
            Buy It Now
          </a>
        </div>
      </div>
    </footer>
  );
}